import { render, staticRenderFns } from "./PhraseResponseList.vue?vue&type=template&id=50e047fa&"
import script from "./PhraseResponseList.vue?vue&type=script&lang=js&"
export * from "./PhraseResponseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports